export const trimObjectStrings = (obj) => {
	if (obj === null || obj === undefined) return obj;

	if (typeof obj === "string") {
		return obj.trim();
	}

	if (obj instanceof Date) {
		return obj;
	}

	if (Array.isArray(obj)) {
		return obj.map(trimObjectStrings);
	}

	if (typeof obj === "object") {
		return Object.fromEntries(
			Object.entries(obj).map(([k, v]) => [k, trimObjectStrings(v)])
		);
	}

	return obj;
};
